// extracted by css-extract-rspack-plugin
export default {"cls1":"ProfileDropdown-cls1_1BH","cls2":"ProfileDropdown-cls2_9Ym ProfileDropdown-cls1_1BH"};